import { NotificationComponent } from "components"

export default function Page() {
    return (
        <div className="mobile:pb-[56px]">
            <NotificationComponent />
        </div>
    )
}